<template>
  <ExpandCard
    ref="hints_expand_card"
    :storeKey="storeKey"
    persistKey="card-trainer-hints"
    :closed
    :canClose
    :icon="'mdi-lightbulb'"
    :title="$t('links.practice_info')"
    :closedTooltip="$t('links.practice_info')"
    style="
      --max-height: var(--max-height-info);
      --content-padding: 0.75rem;
      --radius-open: 4px;
      --tooltip-margin: -2rem 0 0 -1rem;
      --tooltip-transform: translate(-100%, 0);
      --icon-opener-margin: 0 0 0 0;
    "
    tour="tra_live_hints"
    @update:open="open => $emit('update:open', open)"
  >
    <slot />
    <template #title>
      {{ $t('links.practice_info') }}
      <div
        v-if="hasContent"
        class="f-center text-medium ml-auto"
        style="height: 1.5rem; margin: 0 0.5rem 0 0; gap: 0.5rem; --clr-bb: var(--clr-black-3)"
        @click.stop
      >
        <div
          v-if="hintsProps.isICM"
          class="icon_btn csst csst_nm clr-grey"
          style="padding: 0.325rem"
          @click="openPayoutsDialog"
          @mouseenter="e => fl_positionTooltip(e, { placement: 'left' })"
        >
          <i class="mdi mdi-currency-usd text-normal"></i>
          <div
            class="csst_content text-nowrap clr-white text-normal"
            style="position: fixed"
            v-html="$t('tooltips.see_payouts_bubble_factors')"
          ></div>
        </div>
        <div
          class="csst csst_nm"
          @mouseenter="e => fl_positionTooltip(e, { placement: 'left' })"
        >
          <router-link
            class="icon_btn clr-grey"
            target="_blank"
            style="padding: 0.325rem"
            :to="
              links_getLink({
                pathName: 'StudySolutions',
                hasTmpBoard: true,
                asRouterLink: true,
                namespace: hintsProps.namespace,
                customQuery: { soltab: 'strategy' },
              })
            "
          >
            <i class="mdi mdi-school text-normal-large"></i>
          </router-link>
          <div
            class="csst_content tracrls_btn_tooltip text-nowrap clr-white text-medium"
            style="position: fixed"
            v-html="$t('tooltips.study_spot')"
          ></div>
        </div>
        <BtnOpenDetachedTrainerInfo
          data-tst="open_detached_trainer_info"
          class="clr-grey icon_btn text-normal"
          style="padding: 0.35rem"
          :tooltip="$t('tooltips.expand_info')"
          :namespace="hintsProps.namespace"
          @click.stop
        />
      </div>
      <div
        v-else
        class="ml-auto role_spacer"
      ></div>
    </template>

    <TrainerHints
      v-if="hasContent"
      v-bind="hintsProps"
    />
  </ExpandCard>
</template>

<script>
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'
import TrainerHints from '@/components/Trainer/TrainerHints'
import BtnOpenDetachedTrainerInfo from '@/components/SpecialBtns/BtnOpenDetachedTrainerInfo'
import links_mix from '@/mixins/links_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'TrainerHintsExpand',
  components: {
    TrainerHints,
    BtnOpenDetachedTrainerInfo,
    ExpandCard,
  },
  mixins: [float_mix, links_mix],
  props: {
    closed: Boolean,
    hasContent: { type: Boolean, default: true },
    canClose: { type: Boolean, default: true },
    storeKey: { type: String, default: 'expandcard_hints' },
    hintsProps: Object,
  },
  emits: ['update:open'],
  methods: {
    openPayoutsDialog() {
      const dialog = `payouts-dialog_namespace-${this.hintsProps.namespace}_bubble`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
  },
}
</script>
<style lang="scss" scoped>
.traoverv {
  background: var(--clr-black-1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1;
  padding: 0 1rem 1rem 1rem;
  border-bottom-left-radius: 8px;
}
</style>
